---
title: 'Step 5: Configure Collector'
install_track_title: 'Log Insights: Setup (Azure Database for PostgreSQL)'
backlink_href: /docs/log-insights/setup
backlink_title: 'Log Insights: Setup'
---

import CollectorSettings from '../../../components/CollectorSettings'
import CollectorLogTest from '../../../components/CollectorLogTest'

To complete the setup, we can now go to your virtual machine that is running the collector, and enable access to the Azure Event Hub.

Next, update the collector configuration for this server. Note the **values need to match** what you created in Step 2.

<CollectorSettings settings={[
  ['azure_eventhub_namespace', '[namespace from step 2]'],
  ['azure_eventhub_name', '[name from step 2]'],
]} configFromEnv={props.configFromEnv} />

Thanks to the Managed Identity that's assigned to the VM, we don't need to specify any credentials here.
If the VM has multiple Managed Identities assigned, specify the client ID of the specific Managed Identity created in Step 1
using the `azure_ad_client_id` / `AZURE_AD_CLIENT_ID` setting.

<CollectorLogTest provider="Azure Database" configFromEnv={props.configFromEnv} />

For additional help when you get an error please check our
[troubleshooting documentation](https://pganalyze.com/docs/log-insights/setup/azure-database/troubleshooting).

<PublicOnly>
  <p>You will start seeing log data in pganalyze Log Insights within a few minutes.</p>
  <p>
    We recommend setting up <a href="/docs/explain/setup/azure_database/01_auto_explain_check">Automated EXPLAIN</a> as
    a follow-up step, to automatically EXPLAIN slow queries in Postgres.
  </p>
</PublicOnly>
